<template>
    <Modal @close="emitClose">
        <template v-slot:header>
            <div class="d-flex w-100 justify-content-between align-items-center">
                <div></div>
                <h3 class="fw-bold fs-3">Manage Scenarios</h3>
                <button class="btn btn-gray" @click="$emit('close')"><i class="fa fa-close"></i></button>


            </div>

        </template>
        <template v-slot:body>
            <!-- <h1>Manage Scenarios</h1> -->
            <div slot="" class="table-responsive overflow-auto" :class="{
                'border-bottom': caseStore.selectedCaseScenarios.length != 0
            }"
                style="max-height: 515px;">
                <table v-if="caseStore.selectedCaseScenarios.length > 0"
                    class="table border-left border-right overflow-auto w-100" style="min-width: 600px;">
                    <thead class="bg-white sticky-top">
                        <tr class="border-top-0">
                            <th class="fs-5" style="width: 227px;">Name</th>
                            <th class="fs-5 ta-c">Go to Case</th>
                            <th class="fs-5 ta-c" style="width: 130px;">Edit</th>
                            <th class="fs-5 ta-c"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr :key="caseStore.selectedCaseParentCaseId"
                            :class="{ selected: Number($route.params.caseId) === caseStore.selectedCaseParentCaseId }">
                            <td class="">Original Case</td>
                            <td class="ta-c">
                                <button @click="selectCase(caseStore.selectedCaseParentCaseId)" 
                                    v-if="this.$route.params.caseId != caseStore.selectedCaseParentCaseId" class="btn btn-primary">View
                                </button>
                                <span v-else>Current</span>
                            </td>
                            <td v-if="this.$route.params.caseId != caseStore.mainCase?.Id" class="ta-c">
                            </td>
                            <td v-else></td>
                            <td class="ta-c"> </td>


                        </tr>
                        <tr v-for="scenario in caseStore.selectedCaseScenarios" :key="scenario.Id"
                            v-if="caseStore.selectedCaseScenarios.length > 0"
                            :class="{ selected: Number($route.params.caseId) === scenario.Id }">
                            <td class="" v-if="editScenarioId === scenario.Id">
                                    <input v-model="editedScenarioName" class="form-control"
                                        @keyup.enter="saveScenarioName(scenario)" />
                                    <div v-if="scenarioCantBeEmptyMessage" class="text-danger" style="color: red;">
                                        Name can't be empty.
                                    </div>
                                    <div v-if="scenarioNameTooLong" class="text-danger" style="color: red;">Name must be
                                        30 characters or fewer. ({{ editedScenarioName?.length }})</div>
                                    <div v-if="scenarioNameInvalidChars" class="text-danger" style="color: red;">Name
                                        may not contain “; , - :”.</div>

                                
                            </td>
                            <td v-else>{{ scenario.ScenarioName }}</td>

                            <td class="ta-c">
                                <button @click="selectCase(scenario.Id)" v-if="this.$route.params.caseId != scenario.Id"  class="btn btn-primary">View
                                </button>
                                <span v-else>Current</span>
                            </td>

                            <td class="ta-c">
                                <button v-if="editScenarioId !== scenario.Id" class="btn btn-primary-outline"
                                    @click="startEditScenario(scenario)">
                                    <i class="fa fa-pencil"></i>
                                </button>
                                <!-- <div  class="d-flex justify-content-center "> -->
                                    <button class="btn btn-primary mr-3" v-if="editScenarioId == scenario.Id" @click="saveScenarioName(scenario)">
                                        <i class="fa fa-check"></i>
                                    </button>
                                    <button class="btn btn-primary-outline" v-if="editScenarioId == scenario.Id" @click="cancelEdit()">
                                        <i class="fa fa-close"></i>
                                    </button>
                                <!-- </div> -->
                            </td>

                            <td class="ta-c">
                                <button class="btn btn-primary-outline"
                                    @click="showDeleteScenarioModal = true; caseToDelete = scenario">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                        <!-- <tr v-else> 
                        <td class="ta-c">
                            <div class="d-flex flex-column w-100">
                                <div class="d-flex align-items-center justify-content-center">
                                    <div class="fs-5">
                                        No Scenarios
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr> -->
                    </tbody>

                </table>
                <div v-else class="d-flex flex-column w-100">
                    <div class="d-flex align-items-center justify-content-center mt-5 mb-3">
                        <div class="fs-5 ta-c">
                            <!-- You don’t have any scenarios yet. Create one below to create a duplicate copy of your original case. -->
                            Create a new scenario to simulate alternative outcomes without modifying your original case.

                            <!-- <br> </br> -->
                            <!-- This will allow you to simulate alternative outcomes without modifying the original. -->
                            <br> </br>
                            <br> </br>
                            Scenarios you create will be displayed here.
                        </div>

                    </div>
                    <!-- <div class="fs-5 mb-3">
                    You can edit the new scenario without modifying the original case.
                </div> -->
                    <!-- <div>
                    <span class="fw-bold w-25" style="cursor: pointer" @click="showLearnMoreModal = true"> What are Scenarios? <i class="fa fa-question-circle book_auth"></i> </span>
                </div> -->
                </div>
            </div>
            <div class="d-flex justify-content-center mt-3 mb-3">
                <button class="btn btn-primary-outline" @click="showCreateScenarioModalFunction">Create
                    Scenario</button>
            </div>

        </template>
    </Modal>

    <Modal @close="emitClose" v-if="showCreateScenarioModal">
        <template v-slot:header>
            <div class="d-flex w-100 justify-content-between align-items-center">
                <div></div>
                <h3 class="fw-bold fs-3">Create Scenario</h3>
                <button class="btn btn-gray btn-xl" @click="showCreateScenarioModal = false">
                    <i class="fa fa-close"></i>
                </button>
            </div>
        </template>
        <template v-slot:body>
            <div class="d-flex flex-column">
                <div class="pr-4 pl-4">
                    <!-- <p class="fs-5 ta-c">This will clone your original case as as scenario.</p>
                    <p class="fs-5 ta-c">You can then edit the scenario without modifying the original case.</p> -->
                    <!-- <p class="fs-5 ta-c">This will clone your original case as as scenario.</p> -->
                    <p v-if="caseStore.isSelectedCaseParentCase != false" class="fs-5 ta-c">Name your new scenario:</p>
                    
                    <div v-if="caseStore.isSelectedCaseParentCase == false" class="d-flex flex-column mt-3">
                        <!-- <p class="fs-5 mb-2">Name your new scenario:</p> -->
                        <p class="fw-bold fs-4 mb-2"> Clone the original case or the current scenario:</p>
                        <div class="d-flex align-items-center mb-2">
                            <input type="radio" :value="true" name="cloneParentCase" id="originalCase"
                                v-model="cloneParentCase" >
                            <label for="originalCase" class="fs-5 mt-0 pl-1 clickable mb-0">Original Case</label>
                            
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <input type="radio" :value="false" name="currentScenario" id="scenarioCase"
                                v-model="cloneParentCase" >
                            <label for="scenarioCase" class="fs-5 mt-0 pl-1 clickable mb-0">Current Scenario</label>
                        </div>
                    </div>


                    <div class="d-flex flex-column mt-3 ta-c">
                        <!-- <p class="fw-bold fs-5 mt-3 ta-c">New Scenario Name</p> -->
                        <div class="d-flex align-items-center justify-content-center ta-c">
                            <input type="text" class="form-control-lg fs-5 mb-5" placeholder="(i.e Offer)"
                                v-model="scenarioName" />
                            <!-- <input type="text" class="form-control-lg fs-5 mb-5 w-50" placeholder="ie. Offer" v-model="scenarioName" /> -->
                        </div>
                        <div v-if="scenarioNameEmpty" class="text-danger" style="color: red;">Name can’t be empty.</div>
                        <div v-if="scenarioNameTooLong" class="text-danger" style="color: red;">Name must be 30
                            characters or fewer. ({{ scenarioName?.length }})</div>
                        <div v-if="scenarioNameInvalidChars" class="text-danger" style="color: red;">Name may not
                            contain special characters</div>
                    </div>
                </div>
                <div class="d-flex mb-3 ta-c d-flex justify-content-center">
                    <button class="btn btn-primary" @click="createNewScenario()">Create </button>
                </div>

            </div>
        </template>
    </Modal>

    <Modal @close="emitClose" v-if="showDeleteScenarioModal">
        <template v-slot:header>
            <div class="d-flex w-100 justify-content-between align-items-center">
                <div></div>
                <h3 class="fw-bold fs-3">Delete Scenario</h3>
                <button class="btn btn-gray btn-xl" @click="showDeleteScenarioModal = false; caseToDelete = null">
                    <i class="fa fa-close"></i>
                </button>
            </div>
        </template>
        <template v-slot:body>
            <div class="d-flex flex-column ta-c">
                <div class="">
                    <p class="fs-5">Are you sure you want to delete this scenario?</p>
                    <!-- <p class="fs-5">This cannot be undone.</p> -->

                </div>
                <div class="d-flex  mt-3 mb-3">
                    <button class="btn btn-primary" @click="deleteScenario(caseToDelete)">Delete</button>
                </div>

            </div>
        </template>
    </Modal>
   


</template>
<script>
import { main } from '@popperjs/core';
import Modal from '../../../components/utils/Modal.vue';
import { useCaseStore } from "../../../stores/CaseStore";
import axios from "axios";
import { RouterLink } from "vue-router";
import { set } from 'lodash';
export default {
    name: "ManageScenariosModal",
    props: [
        'charges',
    ],
    components: {
        Modal,
        RouterLink
    },

    computed: {
        caseStore() {
            return useCaseStore();
        },
     
    },
    data() {
        return {
            copyScenarioObject: {
                charges: true,
                chargeSettings: true,
                probationLimitations: true,
                probationFactors: true,
                custodyCredits: true,
                releaseDate: true,

                ProbationLimitations: [],
                ProbationFactors: [],
                caseProbationLimitations: [],
                caseProbationFactors: [],
            },
            caseStore: useCaseStore(),
            scenarios: [],
            mainCase: null,
            // selectedCase: null,

            //ids
            selectedCaseId: null,
            editScenarioId: null,
            currentScenarioId: null,

            //modals
            showCreateScenarioModal: false,
            showDeleteScenarioModal: false,
            // showLearnMoreModal: false,

            //string variables
            editedScenarioName: "",
            scenarioName: "",

            //error handling variables
            scenarioCantBeEmptyMessage: false,
            scenarioNameTooLong: false,
            scenarioNameInvalidChars: false,
            scenarioNameEmpty: false,

            //etc 
            caseToDelete: null,
            cloneParentCase: true,
            parentCaseChildren: null,

            loading: false,

        };
    },
    methods: {
        emitClose() {
            this.$emit('close')
        },
        selectCase(caseId) {
            this.caseStore.selectedCaseId = caseId;
            this.$router.push(`/Cases/${caseId}`);
            this.$emit('mount')
        },

        showCreateScenarioModalFunction() {
            this.scenarioName = "";
            this.scenarioCantBeEmptyMessage = false;
            this.scenarioNameTooLong = false;
            this.scenarioNameInvalidChars = false;
            this.showCreateScenarioModal = true;

        },

        startEditScenario(scenario) {
            this.editScenarioId = scenario.Id;
            this.editedScenarioName = scenario.ScenarioName;
            this.scenarioCantBeEmptyMessage = false;
        },

        cancelEdit() {
            this.editScenarioId = null;
            this.editedScenarioName = "";
            this.scenarioCantBeEmptyMessage = false;
            this.scenarioNameTooLong = false;
            this.scenarioNameInvalidChars = false;
        },

        async deleteScenario(scenario) {
            const parentCaseId = scenario?.ParentCaseId ?? scenario?.Id
            await this.caseStore.deleteCase(scenario?.Id);
            if (this.$route.params.caseId == scenario?.Id) {
                this.caseStore.selectedCaseId = parentCaseId
                this.$router.push(`/Cases/${this.caseStore.selectedCaseId}`);
            }
            this.showDeleteScenarioModal = false;
        },

        testString(str) {
            return /^[a-zA-Z0-9 ]*$/.test(str);
        },

        async saveScenarioName(scenario) {
            const name = this.editedScenarioName.trim();

            // reset all errors
            this.scenarioCantBeEmptyMessage = false;
            this.scenarioNameTooLong = false;
            this.scenarioNameInvalidChars = false;

            if (!name) {
                this.scenarioCantBeEmptyMessage = true;
                return;
            }

            if (name === scenario.ScenarioName) {
                this.cancelEdit();
                return;
            }

            if (name.length > 30) {
                this.scenarioNameTooLong = true;
                return;
            }

            // disallowed chars ; , - :
            if (this.testString(this.editedScenarioName) == false) {
                this.scenarioNameInvalidChars = true;
                return;
            }
            

            try {
                const data = await axios.patch(
                    `${process.env.VUE_APP_ENDPOINT}/api/cases/scenarioName/` +
                    `${scenario.Id}/${encodeURIComponent(name)}`,
                    {},
                    { headers: { Authorization: `Bearer ${localStorage.getItem("user_token")}` } }
                );

                if (data.data.success) {
                    scenario.ScenarioName = name;
                    this.cancelEdit();
                } else {
                    console.error("Update failed:", data.data.message);
                }
            } catch (err) {
                console.error("Error updating scenario name:", err);
            }
        },

        async createNewScenario() {
            // console.log('Selected Case Copied Values: ', this.selectedCase)

            this.scenarioNameEmpty = false;
            this.scenarioNameTooLong = false;
            this.scenarioNameInvalidChars = false;

            if (this.scenarioName.length == 0 || !this.scenarioName) {
                this.scenarioNameEmpty = true;
                return;
            }

            if (this.scenarioName.length > 30) {
                this.scenarioNameTooLong = true;
                return;
            }

            if (this.testString(this.scenarioName) == false) {
                this.scenarioNameInvalidChars = true;
                return;
            }

            let scenarioObject = {};


            //user chose original case
            if (this.cloneParentCase) {
                // console.log('chose original case: ', this.mainCase);
                scenarioObject = {
                    CaseNumber: this.caseStore.selectedCaseParentCase?.CaseNumber,
                    ComplaintDate: this.caseStore.selectedCaseParentCase?.ComplaintDate,
                    DefendantBirthdate: this.caseStore.selectedCaseParentCase?.DefendantBirthdate,
                    DefendantFirstName: this.caseStore.selectedCaseParentCase?.DefendantFirstName,
                    DefendantLastName: this.caseStore.selectedCaseParentCase?.DefendantLastName,
                    DefendantMiddleName: this.caseStore.selectedCaseParentCase?.DefendantMiddleName,
                    CaseStatus: this.caseStore.selectedCaseParentCase?.CaseStatus,
                    OwnerId: this.caseStore.selectedCaseParentCase?.OwnerId,
                    HasSuperStrike: this.caseStore.selectedCaseParentCase?.HasSuperStrike,
                    DefendantIs1170Ineligible: this.caseStore.selectedCaseParentCase?.DefendantIs1170Ineligible,
                    ProbationStatus: this.caseStore.selectedCaseParentCase?.ProbationStatus,
                    ScenarioName: this.scenarioName,
                    NumberOfStrikes: this.caseStore.selectedCaseParentCase?.NumberOfStrikes,
                    ParentCaseId: this.caseStore.selectedCaseParentCaseId
                };

                // if (this.caseStore.mainCase?.ParentCaseId) {
                //     scenarioObject.ParentCaseId = this.mainCase?.ParentCaseId;
                // } else {
                //     scenarioObject.ParentCaseId = this.mainCase?.Id;
                // };
                // console.log('copy scenario object: ', this.copyScenarioObject)

                // if (this.copyScenarioObject?.releaseDate) {
                //     scenarioObject.SurrenderDate = this.mainCase?.SurrenderDate;
                // }

                //user chose current scenario
            } else {
                // console.log('chose current case: ', this.selectedCase);
                scenarioObject = {
                    CaseNumber: this.caseStore?.selectedCase?.CaseNumber,
                    ComplaintDate: this.caseStore?.selectedCase?.ComplaintDate,
                    DefendantBirthdate: this.caseStore?.selectedCase?.DefendantBirthdate,
                    DefendantFirstName: this.caseStore?.selectedCase?.DefendantFirstName,
                    DefendantLastName: this.caseStore?.selectedCase?.DefendantLastName,
                    DefendantMiddleName: this.caseStore?.selectedCase?.DefendantMiddleName,
                    CaseStatus: this.caseStore?.selectedCase?.CaseStatus,
                    OwnerId: this.caseStore?.selectedCase?.OwnerId,
                    HasSuperStrike: this.caseStore?.selectedCase?.HasSuperStrike,
                    DefendantIs1170Ineligible: this.caseStore?.selectedCase?.DefendantIs1170Ineligible,
                    ProbationStatus: this.caseStore?.selectedCase?.ProbationStatus,
                    ScenarioName: this.scenarioName,
                    NumberOfStrikes: this.caseStore?.selectedCase?.NumberOfStrikes,
                    ParentCaseId: this.caseStore?.selectedCaseParentCaseId
                };

                // if (this.selectedCase?.ParentCaseId) {
                //     scenarioObject.ParentCaseId = this.selectedCase?.ParentCaseId;
                // } else {
                //     scenarioObject.ParentCaseId = this.selectedCase?.Id;
                // }; 

                // if (this.copyScenarioObject?.releaseDate) {
                //     scenarioObject.SurrenderDate = this.selectedCase?.SurrenderDate;
                // }

            }

            // console.log('Scenario Object:', scenarioObject);

            // console.log('Scenario Object:', scenarioObject);
            const createdCase = await axios.post(process.env.VUE_APP_ENDPOINT + "/api/cases", scenarioObject, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ` + localStorage.getItem("user_token"),
                },
            }).then(res => res.data).catch(err => console.error(err));

            // console.log('createdCase', createdCase);

            // const duplicatedChildren = await this.caseStore.duplicateCaseChildren(this.parentCaseChildren, createdCase.Id);

            // createdCase.caseCircumstances = duplicatedChildren.caseCircumstances;
            // createdCase.caseProbationFactors = duplicatedChildren.caseProbationFactors;
            // createdCase.caseProbationLimitations = duplicatedChildren.caseProbationLimitations;
            // createdCase.charges = duplicatedChildren.charges;

            // const createdResponses = await this.caseStore.createAllCaseChildren(
            //     createdCase.Id,
            //     duplicatedChildren
            // );
            let caseToCloneId = scenarioObject.ParentCaseId;
            if (!this.cloneParentCase) {
                caseToCloneId = this.caseStore.selectedCase?.Id;
            }
            const createdResponses = await this.caseStore.duplicateCase(caseToCloneId, createdCase?.Id);
            // console.log('createdResponses', createdResponses);

            //  const patchCaseChildren = await this.caseStore.patchCaseChildren(createdCase.Id, duplicatedChildren);
            //   console.log('Patch children',patchCaseChildren);
            //   createdCase.caseCircumstances = duplicatedChildren.caseCircumstances;

            // this.selectedCase.push(createdCase);

            //Where to push the new scenario  that was created 
            // this.scenarios.push(createdCase);
            window.location.href = `/Cases/${createdCase.Id}`;
        },
    },

    async mounted() {
        const routeId = this.$route.params.caseId;
        // one call, populates mainCase & scenarios in the store
        this.mainCase = await this.caseStore.loadCaseTree(routeId)
        this.parentCaseChildren = await this.caseStore.loadCaseChildren(routeId);
        // console.log('Parent Case Children:', this.parentCaseChildren);
    },
};
</script>
<style scoped>
/* makes it so the table header is sticky  */
</style>